<template>
    <div
        class="flex gap-2 whitespace-nowrap items-center box-border p-2 cursor-pointer text-sm transition-all hover:bg-gray-200"
        :class="{ 'bg-blue-300': active }"
        @click="handleClick">
        <div class="flex flex-col w-full overflow-hidden">
            <p class="font-bold">
                <span>
                    {{ vehicle.licensePlate }}
                </span>
            </p>
            <template v-if="currentDriver">
                <hts-tooltip>
                    <template #reference>
                        <p>
                            <span>
                                {{ currentDriver.fullName }}
                            </span>
                            <span
                                v-if="currentDriver.phone?.number"
                                class="ml-1">
                                ({{ currentDriver.phone?.code }}) {{ currentDriver.phone?.number }}
                            </span>
                        </p>
                    </template>
                    <p>
                        <span>
                            {{ currentDriver.fullName }}
                        </span>
                        <span
                            v-if="currentDriver.phone?.number"
                            class="ml-1">
                            ({{ currentDriver.phone?.code }}) {{ currentDriver.phone?.number }}
                        </span>
                    </p>
                </hts-tooltip>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
const { $dayjs } = useNuxtApp()
const { data } = $store()
const props = defineProps({
  vehicle: {
    type: Object,
    required: true
  },
  infoType: {
    type: String,
    default: 'vehicle'
  },
  active: Boolean
})
const emits = defineEmits(['click'])
const { vehicle } = toRefs(props)
const drivers = computed(() => data.drivers)
const currentDriver = computed<any>(() => drivers.value.find((d: any) => d._id === vehicle.value.driver))
const minLocationAt = computed(() => $dayjs().valueOf())
const checkLocationAt = (at: string) => {
  if (!at) {
    return false
  }
  return $dayjs(at) < minLocationAt.value
}
const handleClick = (e: any) => {
  emits('click', e)
}
</script>
